var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iSmobileSearch)?_c('div',{staticClass:"mobile_mask_bg",on:{"click":_vm.handleCloseSearch}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }